import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, Select, FormHelperText, Button, Input, MenuItem, DialogActions } from '@material-ui/core';
import { getSampleForms, updateLabResults } from 'utils/SampleFormsUtils'
import { useStyles } from 'components/Samples/SampleDetails/LabResultsTab';
import { useAuthContext } from 'hooks/useAuthContext';
import { NotificationsSnackBar } from 'components/Shared/DynamicForm';
import CenteredCircularProgress from 'components/Shared/CenteredCircularProgress';

const AddTestProcedureDialog = ({ BaseSampleId, sampleByCD, open, onClose, onSumbit }) => {
    const classes = useStyles();
    const [selected, setSelected] = useState('');
    const [availableForms, setAvailableForms] = useState([]);
    const { systemUserId } = useAuthContext();
    const [status, setStatus] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const refreshLagTime = 2000;

    // handling Lab result add dropdown change
    const handleChange = (event) => {
        setSelected(event.target.value);
    }
    
    const submit = async () => {
        setLoading(true);
        const addResult = availableForms.find(r => r.formId === selected);
        const result = await updateLabResults([addResult], BaseSampleId, systemUserId, sampleByCD);
        if (result[0] && result[0].success) {
            setStatus({ success: false, message: "Form was submitted successfully", alertType: "success" });
            await new Promise(res => setTimeout(res, refreshLagTime))
            onSumbit();
            setLoading(false);
        } else {
            setStatus({ success: false, message: "There was an issue submitting the form", alertType: "error" });
            await new Promise(res => setTimeout(res, refreshLagTime));
            setLoading(false);
            // an errror has occurred;
        }
    }

    useEffect(() => {
        getSampleForms(BaseSampleId).then(r => {
            setAvailableForms(r.columns);
            setLoading(false);
        });
        setLoading(true);
    }, [BaseSampleId])

    return (
        <Dialog open={open} onClose={onClose} disableBackdropClick maxWidth={'lg'} >
            {
                !loading ?
                    <>
                        <DialogTitle id="form-dialog-title" className={classes.cardHeader}>Select Test Procedures</DialogTitle>
                        <DialogContent>
                            <Select
                                id="mutiple-chip"
                                style={{ width: "300px", height: "50px" }}
                                value={selected}
                                onChange={handleChange}
                                input={
                                    <Input id="select-multiple-chip" />
                                }
                            >
                                {availableForms.map((name) => (
                                    <MenuItem key={name.formId} value={name.formId} >
                                        {name.formDesc}
                                    </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText>select test procedures to add</FormHelperText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onClose} color="primary"> Cancel</Button>
                            <Button onClick={submit} color="primary">Add Procedure</Button>
                        </DialogActions>
                    </> :
                    <div style={{width: 75, height: 55}}><CenteredCircularProgress /></div>
            }
            <NotificationsSnackBar status={status} setStatus={setStatus} refreshLagTime={refreshLagTime} />
        </Dialog>
    )
};

export default AddTestProcedureDialog;